import { invariant } from '@streem/toolbox';
import { logger } from './logger';
import { checkIfCurrentTimeInHoursOfOperation, findWorkingHoursForGroup, } from './call_transfer_utils';
export function convertGroupToTrade(group, reservation, hoursOfOperation) {
    invariant(group.name, 'group does not have name!');
    const currentGroupName = reservation?.group?.name;
    if (!currentGroupName) {
        // this can happen after the customer clicks end call, but before the call is
        //   torn down completely in EV2
        logger.info(`group not found for reservation: ${reservation}`);
    }
    const maybeWorkingHours = findWorkingHoursForGroup(group.name, hoursOfOperation);
    const inHoursOfOperation = checkIfCurrentTimeInHoursOfOperation(maybeWorkingHours, new Date());
    const isDisabled = group.name === currentGroupName || !inHoursOfOperation;
    return {
        name: group.name,
        disableTransfer: isDisabled,
    };
}
//# sourceMappingURL=convert_group_to_trade.js.map